<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            class="mb-0"
          >
            <v-text-field
              v-model="number"
              :label="$t('code')"
              height="20"
              dense
              outlined
              type="number"
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <v-text-field
              v-model="name"
              :label="$t('caption')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="type"
              :label="$t('type')"
              :items="typeItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="balanceType"
              :label="$t('nature')"
              :items="balanceTypeItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <description
              v-model="content"
              :outlined="true"
              type="sell"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="status"
              :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
              value="active"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import Description from '../../components/general/description/Description'
  export default {
    name: 'Product',
    components: {
      Snakbar,
      Description,
    },
    mixins: [General],
    props: ['item', 'hideClose'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      balanceTypeItems: null,
      content: null,
      balanceType: null,
      alert: false,
      number: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      typeItems: null,
      id: null,
      status: 'active',
      level: 'group',
      group: null,
      loading: false,
    }),
    watch: {
      item (item, oldItem) {
        this.set(item)
      },
    },
    beforeMount () {
      this.typeItems = [
        {
          value: 'balanceSheet',
          text: this.$t('balanceSheet'),
        },
        {
          value: 'costBenefit',
          text: this.$t('costBenefit'),
        },
        {
          value: 'guarantee',
          text: this.$t('guarantee'),
        },
      ]
      this.balanceTypeItems = [
        {
          value: 'notImportant',
          text: this.$t('notImportant'),
        },
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
      ]
    },
    mounted () {
      this.set(this.item)
    },
    methods: {
      set (item) {
        if (this.item) {
          this.id = this.item.id
          this.name = this.item.name
          this.number = this.item.number
          this.type = this.item.type
          this.balanceType = this.item.balance_type
          this.content = this.item.content
          this.status = this.item.status
        } else {
          this.id = null
          this.name = null
          this.number = null
          this.type = null
          this.balanceType = null
          this.content = null
          this.status = 'active'
        }
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'coding', app.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.content = null
            app.balanceType = null
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.$emit('close')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'coding/' + this.id, this.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.content = null
            app.balanceType = null
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.$emit('close')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
